/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Access_Label_DatasetInputs */



/**
* | output |
* | --- |
* | "Dataset \"{name}\"" |
*
* @param {Agent_Access_Label_DatasetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_label_dataset = /** @type {((inputs: Agent_Access_Label_DatasetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Label_DatasetInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Datensatz „${i?.name}“`)
	return /** @type {LocalizedString} */ (`Dataset "${i?.name}"`)
});